import { COMBAT_VEHICLE_TEST_SCENARIOS, type ClientDeveloperCommand } from "@endclock/shared";
import type { EndclockGame } from "../game/game.js";

/** Uses the existing password-authorized developer panel and server command gate. */
export function setupWarfareDeveloperTools(game: EndclockGame): void {
  const panel = document.querySelector<HTMLElement>("#developer-panel");
  if (!panel) return;
  const section = document.createElement("details");
  section.id = "developer-warfare";
  const heading = document.createElement("summary");
  heading.textContent = "AUTONOMOUS BATTLE";
  section.append(heading);
  const button = (label: string, id: string, action: () => void) => {
    const element = document.createElement("button");
    element.type = "button"; element.id = id; element.textContent = label;
    element.addEventListener("click", () => { if (game.network.developer.authorized) action(); });
    section.append(element);
  };
  const command = (value: ClientDeveloperCommand) => game.network.developerGameplayCommand(value);
  button("VIEW BATTLE", "battle-observe", () => game.observeBattle());
  button("RESET", "battle-reset", () => command({ t: "dev_cmd", command: "battle_reset" }));
  button("PAUSE", "battle-pause", () => command({ t: "dev_cmd", command: "battle_pause", enabled: true }));
  button("RESUME", "battle-resume", () => command({ t: "dev_cmd", command: "battle_pause", enabled: false }));
  button("12 HOUNDS / 3 BASTIONS / 2 ROVERS", "battle-standard", () => command({ t: "dev_cmd", command: "battle_preset", hounds: 12, bastions: 3, technicals: 2 }));
  button("ADD HOUND", "battle-add-hound", () => command({ t: "dev_cmd", command: "battle_spawn", actorType: 0 }));
  button("ADD BASTION", "battle-add-bastion", () => command({ t: "dev_cmd", command: "battle_spawn", actorType: 1 }));
  button("ADD ROVER TECHNICAL", "battle-add-technical", () => command({ t: "dev_cmd", command: "battle_spawn", actorType: 2 }));
  const vehicleTests = document.createElement("details"), vehicleHeading = document.createElement("summary");
  vehicleHeading.textContent = "VEHICLE TEST SCENARIOS"; vehicleTests.append(vehicleHeading);
  for (const scenario of COMBAT_VEHICLE_TEST_SCENARIOS) {
    const test = document.createElement("button"); test.type = "button"; test.textContent = scenario.toUpperCase();
    test.addEventListener("click", () => { if (game.network.developer.authorized)
      command({ t: "dev_cmd", command: "battle_vehicle_test", scenario }); });
    vehicleTests.append(test);
  }
  section.append(vehicleTests);
  const label = document.createElement("label");
  const optIn = document.createElement("input");
  optIn.type = "checkbox"; optIn.id = "battle-player-damage";
  optIn.addEventListener("change", () => command({ t: "dev_cmd", command: "battle_player_damage", enabled: optIn.checked }));
  label.append(optIn, " Test explosion injuries on my player");
  section.append(label);
  panel.append(section);
}
